import { Injectable, Inject } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { NavigationEnd, Router, NavigationStart, NavigationError } from '@angular/router';
import { BaseTrackingService } from '@app/tracking/base-tracking.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { TrackingEvent } from '@app/models/tracking-event';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService implements BaseTrackingService {

  appInsights: ApplicationInsights;
  routerSubscription: Subscription;
  loadStartTime: number;
  loadTime: number;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment,
    private titleService: Title,
    private router: Router) {
    if (this.environment.appInsightsTrackingKey) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: this.environment.appInsightsTrackingKey,
          enableDebug: !this.environment.production
        }
      });

      this.appInsights.loadAppInsights();

      this.router.events
        .pipe(
          filter(event => event instanceof NavigationStart))
        .subscribe(() => {
          this.loadStartTime = Date.now();
          this.loadTime = null;
        });

      this.router.events.pipe(
        filter(event => event instanceof NavigationError || event instanceof NavigationEnd))
        .subscribe(
          (event) => {
            this.loadTime = Date.now() - this.loadStartTime;
            this.loadStartTime = null;
            if (event instanceof NavigationEnd) {
              this.trackRouterEvent(event);
            }
          });
    }
  }

  public trackRouterEvent(event: NavigationEnd): void {
    if (this.appInsights) {
      const headerTitle = this.titleService.getTitle();
      this.appInsights.trackPageView({ uri: event.urlAfterRedirects, name: headerTitle, properties: { duration: this.loadTime } });
    }
  }

  trackEvent(event: TrackingEvent): void {
    if (this.appInsights) {
      event.properties.currentRoute = this.router.url;
      this.appInsights.trackEvent({ name: event.name, properties: event.properties });
    }
  }

  trackException(): void {
    throw new Error('Method not implemented.');
  }
}
